import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StockTableDtService } from '../../../../routes/jy-srm/contract-order-execute/receiving-management/receiving-query/stock-table-dt.service';
import { BrowseService } from '@shared/components/browse/browse.service';

@Component({
  selector: 'app-stock-table-dt-browse',
  templateUrl: './stock-table-dt-browse.component.html',
  styles: []
})
export class StockTableDtBrowseComponent implements BrowseComponent, OnInit {

  static componentName='StockTableDtBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  pagination: Pagination = new Pagination();

  constructor(
    private commonsService: CommonsService,
    private modalService: NzModalService,
    private browseService: BrowseService,
    private stockTableDtService: StockTableDtService
  ) {
    this.pagination.getData = function (params: HttpParams): Observable<any> {
      return stockTableDtService.query(params);
    }
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.pagination.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }


  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

}
